/**
 * @fileoverview Alert message component for Click&Pledge notifications.
 * Displays success and error messages with auto-hide functionality.
 */

import React, { useState } from 'react';

/**
 * Alert message component that displays success or failure notifications.
 * Automatically hides after 8 seconds and supports callback functions.
 *
 * @param {Object} props - Component props
 * @param {string} props.message - Main alert message to display
 * @param {string} props.subMessage - Optional secondary message
 * @param {string} props.type - Alert type: "success" or "failure"
 * @param {boolean} props.isClose - Whether to auto-close the alert
 * @param {Function} props.callfunc - Optional callback function when alert closes
 * @returns {ReactElement} The rendered alert component
 */
function AlertMsg(props) {

    const [ showMessage, setShowMessage ] = useState(true);

    // subMessage
    if (props.message && props.isClose) {
        setTimeout(() => {
            setShowMessage(false);
            if (props.callfunc) {
                props.callfunc();
            }
        }, [ 8000 ]);
    }

    return (
        <div className = { `alert-container ${showMessage ? 'show' : 'hide'}` }>
            {props.type === 'success' && (
                <div className = 'recurring_successful_transaction_wrapper'>
                    <div className = 'succesful_transaction_wrapper' >
                        {props.message && <p className = 'title'>{props.message}</p>}
                        {props.subMessage && <p>{props.subMessage}</p>}
                    </div>
                    {/* <img src="./newimgs/success-icon.svg" alt="success" /> */}

                </div>
            )}
            {props.type === 'failure' && (
                <div className = 'recurring_error_transaction_wrapper'>
                    <div className = 'error_transaction_wrapper'>
                        {props.message && <p className = 'title'>{props.message}</p>}
                        {props.subMessage && <p className = 'title'>{props.subMessage}</p>}
                    </div>
                    {/* <img src="./newimgs/error-icon.svg" alt="success" /> */}

                </div>
            )}
        </div>
    );
}

export default AlertMsg;
